import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { content } from "../data/content";
import { Check, Copy, Twitter } from "lucide-react";

// Classic Filled LinkedIn Icon
const LinkedInIcon = ({ className }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 24 24" 
        fill="currentColor" 
        className={className}
    >
        <path d="M20.5 2h-17A1.5 1.5 0 002 3.5v17A1.5 1.5 0 003.5 22h17a1.5 1.5 0 001.5-1.5v-17A1.5 1.5 0 0020.5 2zM8 19H5v-9h3zM6.5 8.25A1.75 1.75 0 118.3 6.5a1.78 1.78 0 01-1.8 1.75zM19 19h-3v-4.74c0-1.42-.6-1.93-1.38-1.93A1.74 1.74 0 0013 14.19V19h-3v-9h2.9v1.3a3.11 3.11 0 012.7-1.4c1.55 0 3.36.86 3.36 3.66z"></path>
    </svg>
);

const Contact = () => {
  const { lang } = useLanguage();
  const t = content[lang].contact;
  const [copied, setCopied] = useState(false);

  const copyEmail = (e) => {
    e.preventDefault();
    navigator.clipboard.writeText(t.email);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <section className="py-16 pb-16">
       <div className="max-w-4xl mx-auto px-6 border-t border-border pt-16">
          <div className="flex flex-col md:flex-row md:items-start justify-between gap-12">
              <div className="flex flex-col gap-8">
                  <div className="flex flex-col gap-2">
                      <span className="text-sm text-muted-foreground">{t.label}</span>
                      <a href={`mailto:${t.email}`} className="text-2xl md:text-3xl font-semibold hover:underline decoration-primary decoration-2 underline-offset-8">
                          {t.email}
                      </a>
                  </div>
                  
                  {/* Social Links */}
                  <div className="flex flex-col gap-6">
                      {t.socialLink && (
                        <div className="flex flex-col gap-2">
                             <span className="text-sm text-muted-foreground">{t.social}</span>
                             <a 
                                href={t.socialLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-lg font-medium hover:text-primary transition-colors"
                             >
                                <Twitter className="w-5 h-5" />
                                <span>@michalfolprecht</span>
                             </a>
                        </div>
                      )}

                      {t.linkedinLink && (
                        <div className="flex flex-col gap-2">
                             <span className="text-sm text-muted-foreground">{t.linkedin}</span>
                             <a 
                                href={t.linkedinLink}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-2 text-lg font-medium hover:text-primary transition-colors"
                             >
                                <LinkedInIcon className="w-5 h-5" />
                                <span>Michal Folprecht</span>
                             </a>
                        </div>
                      )}
                  </div>
              </div>
              
              <button 
                onClick={copyEmail}
                className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-border hover:bg-secondary transition-colors text-muted-foreground hover:text-foreground self-start mt-2"
              >
                  {copied ? <Check className="w-4 h-4 text-green-500" /> : <Copy className="w-4 h-4" />}
                  <span className="text-sm font-medium">{copied ? 'Copied' : 'Copy'}</span>
              </button>
          </div>
          
          <div className="mt-24 pt-8 border-t border-border/40 text-center text-sm text-muted-foreground">
                &copy; {new Date().getFullYear()} Michal Folprecht. All rights reserved.
          </div>
       </div>
    </section>
  );
};

export default Contact;
